import React, { useEffect, useState } from 'react';
import { Row, Col, Form, FormGroup } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { MdSearch } from 'react-icons/md';
import styled from 'styled-components';
import { fetchCatalogManufacturers, fetchCatalogCategories } from '../../../services/Http/Api';
import { SearchableSelect } from '../../../shared/layout/forms/AppSelect';

const ProductsSearchFilters = ({ onFilter }) => {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');
    const [manufacturerId, setManufacturerId] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [manufacturers, setManufacturers] = useState([]);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const loadOptions = async () => {
            try {
                const [manufacturersData, categoriesData] = await Promise.all([
                    fetchCatalogManufacturers(),
                    fetchCatalogCategories(),
                ]);
                setManufacturers(manufacturersData || []);
                setCategories(categoriesData || []);
            } catch (error) {
                console.error('Error fetching catalog filters:', error);
            }
        };

        loadOptions();
    }, []);

    const handleSearch = (event) => {
        event.preventDefault();
        onFilter({
            searchTerm,
            manufacturerId: manufacturerId || null,
            categoryId: categoryId || null,
        });
    };

    return (
        <Form onSubmit={handleSearch}>
            <Row className="align-items-end">
                <Col md="4">
                    <FormGroup>
                        <StyledInput
                            type="text"
                            value={searchTerm}
                            onChange={(event) => setSearchTerm(event.target.value)}
                            placeholder={t('Products.SearchFilters.search_placeholder')}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <SearchableSelect
                            placeholder={t('Products.SearchFilters.select_manufacturer')}
                            options={manufacturers.map((manufacturer) => ({
                                value: manufacturer.id,
                                label: manufacturer.items_count
                                    ? `${manufacturer.name} (${manufacturer.items_count})`
                                    : manufacturer.name,
                            }))}
                            value={manufacturerId}
                            onChange={(event, nextValue) => setManufacturerId(nextValue ?? event?.target?.value ?? '')}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <SearchableSelect
                            placeholder={t('Products.SearchFilters.select_category')}
                            options={categories.map((category) => ({
                                value: category.id,
                                label: category.items_count
                                    ? `${category.name || category.path} (${category.items_count})`
                                    : (category.name || category.path),
                            }))}
                            value={categoryId}
                            onChange={(event, nextValue) => setCategoryId(nextValue ?? event?.target?.value ?? '')}
                        />
                    </FormGroup>
                </Col>
                <Col md="12" className="text-end">
                    <SearchButton type="submit">
                        <MdSearch className="icon" />
                        {t('Products.SearchFilters.search_button')}
                    </SearchButton>
                </Col>
            </Row>
        </Form>
    );
};

export default ProductsSearchFilters;

const StyledInput = styled.input`
    padding: 0.625rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
    outline: none;
    width: 100%;

    &:focus {
        border-color: rgba(130, 22, 146, 0.8);
        box-shadow: 0 0 5px rgba(130, 22, 146, 0.5);
    }
`;

const SearchButton = styled.button`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: rgba(130, 22, 146, 1);
    color: white;
    border: none;
    border-radius: 5px;
    padding: 0.625rem 0.9375rem;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: rgba(130, 22, 146, 0.9);
    }

    .icon {
        font-size: 1.2rem;
    }
`;
